import { render, staticRenderFns } from "./demo_scroll.vue?vue&type=template&id=10a14698"
import script from "./demo_scroll.vue?vue&type=script&lang=js"
export * from "./demo_scroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports